import { render, staticRenderFns } from "./LogoBGF.vue?vue&type=template&id=37107010&"
import script from "./LogoBGF.vue?vue&type=script&lang=js&"
export * from "./LogoBGF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports